import React from 'react';

import Checkbox from '@zvuk-b2b/react-uikit/ui/Checkbox';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import StreamPreviewItemContent from 'application/components/StreamPreviewItem/StreamPreviewItemContent';
import AnalyticsService, { ParamNameAMP } from 'application/services/AnalyticsService';
import { ThematicEventNameAMP } from 'application/services/AnalyticsService/ampTypes';
import styles from './index.module.scss';
import { POINTS_TYPES_ENUM } from '../StreamPreviewCardRenderer';

interface StreamPreviewCardProps {
  id: string;
  title: string;
  description: string;
  imgLink: string | undefined;
  streamIds: Map<string, boolean>;
  type: POINTS_TYPES_ENUM;
  setStreamIds: React.Dispatch<React.SetStateAction<Map<string, boolean>>>;
  setIsAllSelected: React.Dispatch<React.SetStateAction<boolean>>;
}

const StreamPreviewCard = (props: StreamPreviewCardProps) => {
  const { id, title, description, imgLink, streamIds, type, setStreamIds, setIsAllSelected } = props;

  const isChecked = streamIds.has(id);

  const handleCheck = () => {
    const isWithoutPointType = type === POINTS_TYPES_ENUM.WITHOUT_POINT;
    const currentEventName = isWithoutPointType
      ? ThematicEventNameAMP.WAVES_WITHOUT_ADDRESS_CHECKBOX_CLICKED
      : ThematicEventNameAMP.WAVES_WITH_ADDRESS_CHECKBOX_CLICKED;

    AnalyticsService.event(currentEventName, { [ParamNameAMP.TYPE]: !isChecked });

    setStreamIds((prevStreamIds) => {
      const newStreamIds = new Map(prevStreamIds);

      if (newStreamIds.has(id)) {
        newStreamIds.delete(id);
      } else {
        newStreamIds.set(id, true);
      }

      return newStreamIds;
    });
    setIsAllSelected(false);
  };

  return (
    <Button
      className={styles.StreamPreviewItemCard}
      onClick={handleCheck}
      elementId={`thematic_stream_preview_card_${id}`}
      type={ButtonType.PLAIN}>
      <StreamPreviewItemContent
        link={imgLink}
        title={title}
        description={description}
      />
      <Checkbox
        elementId="stream_ny_modal_checkbox"
        isChecked={isChecked}
        className={styles.StreamPreviewItemCardCheckbox}
      />
    </Button>
  );
};
export default StreamPreviewCard;
